const projectsData = [
    {
        title: "DOM W MIROWIE",
        content: "",
        images: [
            "/strona-www/DOM W MIROWIE/0.jpg",
            "/strona-www/DOM W MIROWIE/1.jpg",
            "/strona-www/DOM W MIROWIE/2.jpg",
            "/strona-www/DOM W MIROWIE/3.jpg",
            "/strona-www/DOM W MIROWIE/4.jpg",
            "/strona-www/DOM W MIROWIE/5.jpg",
            "/strona-www/DOM W MIROWIE/6.jpg",
            "/strona-www/DOM W MIROWIE/7.jpg",
        ]
    },
    {
        title: "DOM W SPALONEJ",
        content: "",
        images: [
            "/strona-www/DOM W SPALONEJ/0.jpg",
            "/strona-www/DOM W SPALONEJ/1.jpg",
            "/strona-www/DOM W SPALONEJ/2.jpg",
            "/strona-www/DOM W SPALONEJ/3.jpg",
            "/strona-www/DOM W SPALONEJ/4.jpg",
            "/strona-www/DOM W SPALONEJ/5.jpg",
            "/strona-www/DOM W SPALONEJ/6.jpg",
        ]
    },
    {
        title: "DOM W SOSNOWCU",
        content: "",
        images: [
            "/strona-www/DOM W SOSNOWCU/0.jpg",
            "/strona-www/DOM W SOSNOWCU/1.jpg",
            "/strona-www/DOM W SOSNOWCU/2.png",
            "/strona-www/DOM W SOSNOWCU/3.jpg",
            "/strona-www/DOM W SOSNOWCU/4.jpg",
            "/strona-www/DOM W SOSNOWCU/5.jpg",
            "/strona-www/DOM W SOSNOWCU/6.jpg",
            "/strona-www/DOM W SOSNOWCU/7.jpg",
            "/strona-www/DOM W SOSNOWCU/9.png",
        ]
    },

    {
        title: "KONCEPCJA SIEDZIBY NADLEŚCNICTWA W WIELUNIU",
        content: "",
        images: [
            "/strona-www/KONCEPCJA SIEDZIBY NADLEŚNICTWA W WIELUNIU/0.jpg",
            "/strona-www/KONCEPCJA SIEDZIBY NADLEŚNICTWA W WIELUNIU/1.jpg",
            "/strona-www/KONCEPCJA SIEDZIBY NADLEŚNICTWA W WIELUNIU/2.jpg",
            "/strona-www/KONCEPCJA SIEDZIBY NADLEŚNICTWA W WIELUNIU/3.jpg",
            "/strona-www/KONCEPCJA SIEDZIBY NADLEŚNICTWA W WIELUNIU/4.jpg",
            "/strona-www/KONCEPCJA SIEDZIBY NADLEŚNICTWA W WIELUNIU/5.jpg",
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W OKOCIMIU",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W OKOCIMIU/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W OKOCIMIU/1.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W OKOCIMIU/2.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W OKOCIMIU/3.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W OKOCIMIU/4.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W OKOCIMIU/5.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W OKOCIMIU/6.jpg"
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W WĘGRZCACH",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W WĘGRZCACH/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W WĘGRZCACH/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W WĘGRZCACH/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W WĘGRZCACH/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W WĘGRZCACH/4.png",
            "/strona-www/BUDYNEK MIESZKALNY W WĘGRZCACH/5.png"
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W SIERADZU",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W SIERADZU/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W SIERADZU/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W SIERADZU/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W SIERADZU/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W SIERADZU/4.png",
            "/strona-www/BUDYNEK MIESZKALNY W SIERADZU/5.png"
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W MUSZYNIE",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W MUSZYNIE/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W MUSZYNIE/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W MUSZYNIE/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W MUSZYNIE/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W MUSZYNIE/4.png",
            "/strona-www/BUDYNEK MIESZKALNY W MUSZYNIE/5.png"
        ]
    },
    {

        title: "BUDYNEK MIESZKALNY W KAJETANACH",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/4.png",
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/5.png",
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/6.png",
            "/strona-www/BUDYNEK MIESZKALNY W KAJETANACH/7.png"
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W MAKOWIE PODHALAŃSKIM",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W MAKOWIE PODHALAŃSKIM/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W MAKOWIE PODHALAŃSKIM/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W MAKOWIE PODHALAŃSKIM/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W MAKOWIE PODHALAŃSKIM/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W MAKOWIE PODHALAŃSKIM/4.png"
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W MIEJSCOWOŚCI WALNE",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W MIEJSCOWOŚCI WALNE/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W MIEJSCOWOŚCI WALNE/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W MIEJSCOWOŚCI WALNE/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W MIEJSCOWOŚCI WALNE/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W MIEJSCOWOŚCI WALNE/4.png"
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W NAWOJOWEJ",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W NAWOJOWEJ/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W NAWOJOWEJ/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W NAWOJOWEJ/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W NAWOJOWEJ/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W NAWOJOWEJ/4.png",
            "/strona-www/BUDYNEK MIESZKALNY W NAWOJOWEJ/5.png"
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM",
        content: "",
        images: [
            "/strona-www/BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM/0.jpg",
            "/strona-www/BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM/1.png",
            "/strona-www/BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM/2.png",
            "/strona-www/BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM/3.png",
            "/strona-www/BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM/4.png",
            "/strona-www/BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM/5.png",
            "/strona-www/BUDYNEK MIESZKALNY W OŻAROWIE MAZOWIECKIM/6.png"
        ]
    },
    {

        title: "BUDYNEK MIESZKALNY W PĘCLINIE",
        content: "",
        images: [
            "/strona-www/15_BUDYNEK MIESZKALNY W PECLINIE/0.jpg",
            "/strona-www/15_BUDYNEK MIESZKALNY W PECLINIE/1.png",
            "/strona-www/15_BUDYNEK MIESZKALNY W PECLINIE/2.png",
            "/strona-www/15_BUDYNEK MIESZKALNY W PECLINIE/3.png",
            "/strona-www/15_BUDYNEK MIESZKALNY W PECLINIE/4.png",
            "/strona-www/15_BUDYNEK MIESZKALNY W PECLINIE/5.png",
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W RAWIE MAZOWIECKIEJ",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/rawa_mazowiecka/0.jpg",
            "/strona-www/rawa_mazowiecka/1.png",
            "/strona-www/rawa_mazowiecka/2.png",
            "/strona-www/rawa_mazowiecka/3.png",
            "/strona-www/rawa_mazowiecka/4.png",
            "/strona-www/rawa_mazowiecka/5.png",
            "/strona-www/rawa_mazowiecka/6.png",
            "/strona-www/rawa_mazowiecka/7.png",
        ],
    },
    {
        title: "BUDYNEK MIESZKALNY W ŁODZI",
        content: "",
        images: [
            "/strona-www/16_BUDYNEK MIESZKALNY W LODZI/0.jpg",
            "/strona-www/16_BUDYNEK MIESZKALNY W LODZI/1.jpg",
            "/strona-www/16_BUDYNEK MIESZKALNY W LODZI/2.jpg",
            "/strona-www/16_BUDYNEK MIESZKALNY W LODZI/3.jpg",
            "/strona-www/16_BUDYNEK MIESZKALNY W LODZI/4.jpg",
            "/strona-www/16_BUDYNEK MIESZKALNY W LODZI/5.jpg",
            "/strona-www/16_BUDYNEK MIESZKALNY W LODZI/6.jpg",
        ]
    },
    {
        title: "BUDYNEK MIESZKALNY W WIELICZCE",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/wieliczka/0.jpg",
            "/strona-www/wieliczka/1.png",
            "/strona-www/wieliczka/2.png",
            "/strona-www/wieliczka/3.png",
            "/strona-www/wieliczka/4.png",
        ],
    },
    {
        title: "BUDYNEK USŁUGI TURYSTYCZNEJ W ZŁOTNIE",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/zlotno/0.jpg",
            "/strona-www/zlotno/1.png",
            "/strona-www/zlotno/2.png",
            "/strona-www/zlotno/3.png",
            "/strona-www/zlotno/4.png",
            "/strona-www/zlotno/5.png",
        ],
    },

    {
        title: "BUDYNEK MIESZKALNY W KOPKACH",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/kopki/0.jpg",
            "/strona-www/kopki/1.png",
            "/strona-www/kopki/2.png",
            "/strona-www/kopki/3.png",
            "/strona-www/kopki/4.png",
            "/strona-www/kopki/5.png",
        ],
    },
    {
        title: "BUDYNEK MIESZKALNY JEDNORODZINNY W KATOWICACH",
        content: "",
        images: [
            "/strona-www/17_BUDYNEK MIESZKALNY JEDNORODZINNY W KATOWICACH/0.jpg",
            "/strona-www/17_BUDYNEK MIESZKALNY JEDNORODZINNY W KATOWICACH/1.png",
            "/strona-www/17_BUDYNEK MIESZKALNY JEDNORODZINNY W KATOWICACH/2.png",
            "/strona-www/17_BUDYNEK MIESZKALNY JEDNORODZINNY W KATOWICACH/3.png",
            "/strona-www/17_BUDYNEK MIESZKALNY JEDNORODZINNY W KATOWICACH/4.png",
            "/strona-www/17_BUDYNEK MIESZKALNY JEDNORODZINNY W KATOWICACH/5.png",
        ]
    },
    {
        title: "DOM JEDNORODZINNY - 23P1",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY - 23P1/0.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P1/1.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P1/2.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P1/3.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P1/4.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P1/5.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P1/6.jpg",
        ],
    },
    // {
    //     title: "DOM JEDNORODZINNY W BIAŁEJ RAWSKIEJ",
    //     content: "Jest to projekt hotelu w uściu gorlickim",
    //     images: [
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/0.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/1.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/2.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/3.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/4.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/5.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/6.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/7.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/8.jpg",
    //         "/strona-www/16_DOM JEDNORODZINNY W BIALEJ RAWSKIEJ/9.jpg",
    //     ],
    // },
    {
        title: "REZYDENCJA W TANZANII",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/2_REZYDENCJA W TANZANII/0.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/1.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/2.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/3.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/4.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/5.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/6.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/7.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/8.jpg",
            "/strona-www/2_REZYDENCJA W TANZANII/9.jpg",
        ],
    },
    {
        title: "KONCEPCJA PAWILONU WEJŚCIOWEGO W PARKU MINIATUR W ZABIERZOWIE",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/5_KONCEPCJA PAWILONU WEJŚCIOWEGO W PARKU MINIATUR W ZABIERZOWIE/0.jpg",
            "/strona-www/5_KONCEPCJA PAWILONU WEJŚCIOWEGO W PARKU MINIATUR W ZABIERZOWIE/1.jpg",
            "/strona-www/5_KONCEPCJA PAWILONU WEJŚCIOWEGO W PARKU MINIATUR W ZABIERZOWIE/2.jpg",
            "/strona-www/5_KONCEPCJA PAWILONU WEJŚCIOWEGO W PARKU MINIATUR W ZABIERZOWIE/3.jpg",
            "/strona-www/5_KONCEPCJA PAWILONU WEJŚCIOWEGO W PARKU MINIATUR W ZABIERZOWIE/4.jpg",
            "/strona-www/5_KONCEPCJA PAWILONU WEJŚCIOWEGO W PARKU MINIATUR W ZABIERZOWIE/5.jpg",
        ],
    },
    {
        title: "KONCEPCJA BUDYNKU BIUROWEGO PZU W ŁODZI",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/12_KONCEPCJA BUDYNKU BIUROWEGO PZU W ŁODZI/0.jpg",
            "/strona-www/12_KONCEPCJA BUDYNKU BIUROWEGO PZU W ŁODZI/1.jpg",
            "/strona-www/12_KONCEPCJA BUDYNKU BIUROWEGO PZU W ŁODZI/2.jpg",
            "/strona-www/12_KONCEPCJA BUDYNKU BIUROWEGO PZU W ŁODZI/3.jpg",
        ],
    },

    {
        title: "DOM JEDNORODZINNY - 23P2",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY - 23P2/0.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P2/1.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P2/2.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P2/3.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P2/4.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P2/4.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23P2/6.jpg",
        ],
    },

    {
        title: "HOTEL SEMIRAMIS W TANZANII",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/0.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/1.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/2.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/3.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/4.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/5.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/6.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/7.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/8.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/9.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/10.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/11.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/12.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/13.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/14.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/15.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/16.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/17.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/18.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/19.jpg",
            "/strona-www/3_HOTEL SEMIRAMIS W TANZANII/20.jpg",
        ],
    },
    {
        title: "BIUROWIEC QMODULAR W WĘGRZCACH WIELKICH",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/15_BIUROWIEC QMODULAR W WĘGRZCACH WIELKICH/2.jpg",
            "/strona-www/15_BIUROWIEC QMODULAR W WĘGRZCACH WIELKICH/2.jpg",
            "/strona-www/15_BIUROWIEC QMODULAR W WĘGRZCACH WIELKICH/1.jpg",
            "/strona-www/15_BIUROWIEC QMODULAR W WĘGRZCACH WIELKICH/3.jpg",
            "/strona-www/15_BIUROWIEC QMODULAR W WĘGRZCACH WIELKICH/4.jpg",
        ],
    },
    {
        title: "HOTEL W UŚCIU GORLICKIM",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/1_HOTEL W UŚCIU GORLICKIM/0.jpg",
            "/strona-www/1_HOTEL W UŚCIU GORLICKIM/1.jpg",
            "/strona-www/1_HOTEL W UŚCIU GORLICKIM/2.jpg",
            "/strona-www/1_HOTEL W UŚCIU GORLICKIM/3.jpg",
            "/strona-www/1_HOTEL W UŚCIU GORLICKIM/5.jpg",
        ],
    },
    {
        title: "BUDYNEK WIELORODZINNY W KRAKOWIE NA UL. KOBIERZYŃSKIEJ",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/0.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/1.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/2.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/3.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/4.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/5.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/6.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/7.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/8.jpg",
            "/strona-www/4_BUDYNEK WIELORODZINNY W KRAKOWIE NA ULICY KOBIERZYŃSKIEJ/9.jpg",
        ],
    },
    {
        title: "ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/10_ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM/0.jpg",
            "/strona-www/10_ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM/1.jpg",
            "/strona-www/10_ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM/2.jpg",
            "/strona-www/10_ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM/3.jpg",
            "/strona-www/10_ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM/4.jpg",
            "/strona-www/10_ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM/5.jpg",
            "/strona-www/10_ZESPÓŁ BUDYNKÓW WIELORODZINNYCH W KONINIE ŻEGAŃSKIM/6.jpg",
        ],
    },
    {
        title: "BUDYNEK MIESZKALNY W KRAKOWIE NA ULICY TYNIECKIEJ",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/7_BUDYNEK JEDNORODZINNY NA ULICY TYNIECKIEJ W KRAKOWIE/0.jpg",
            "/strona-www/7_BUDYNEK JEDNORODZINNY NA ULICY TYNIECKIEJ W KRAKOWIE/1.png",
            "/strona-www/7_BUDYNEK JEDNORODZINNY NA ULICY TYNIECKIEJ W KRAKOWIE/2.png",
            "/strona-www/7_BUDYNEK JEDNORODZINNY NA ULICY TYNIECKIEJ W KRAKOWIE/3.png",
            "/strona-www/7_BUDYNEK JEDNORODZINNY NA ULICY TYNIECKIEJ W KRAKOWIE/4.png",
        ],
    },
    {
        title: "MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/0.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/1.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/2.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/3.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/4.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/5.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/6.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/7.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/8.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/9.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/10.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/11.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/12.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/13.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/14.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/15.jpg",
            "/strona-www/11_MODULARCITY - KONCEPCJA HOTELI MODUŁOWYCH/16.jpg",
        ],
    },

    {
        title: "KONCEPCJA PAWILONU GASTRONOMICZNEGO W RUDAWIE",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/13_KONCEPCJA PAWILONU GASTRONOMICZNEGO W RUDAWIE/0.jpg",
            "/strona-www/13_KONCEPCJA PAWILONU GASTRONOMICZNEGO W RUDAWIE/1.jpg",
            "/strona-www/13_KONCEPCJA PAWILONU GASTRONOMICZNEGO W RUDAWIE/2.jpg",
            "/strona-www/13_KONCEPCJA PAWILONU GASTRONOMICZNEGO W RUDAWIE/3.jpg",
            "/strona-www/13_KONCEPCJA PAWILONU GASTRONOMICZNEGO W RUDAWIE/4.jpg",
            "/strona-www/13_KONCEPCJA PAWILONU GASTRONOMICZNEGO W RUDAWIE/5.jpg",
        ],
    },

    {
        title: "MODUŁOWY BUDYNEK LETNISKOWY W CHORWACJI",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/8_MODUŁOWY BUDYNEK LETNISKOWY W CHORWACJI/0.jpg",
            "/strona-www/8_MODUŁOWY BUDYNEK LETNISKOWY W CHORWACJI/1.jpg",
            "/strona-www/8_MODUŁOWY BUDYNEK LETNISKOWY W CHORWACJI/2.jpg",
            "/strona-www/8_MODUŁOWY BUDYNEK LETNISKOWY W CHORWACJI/3.jpg",
            "/strona-www/8_MODUŁOWY BUDYNEK LETNISKOWY W CHORWACJI/4.jpg",
            "/strona-www/8_MODUŁOWY BUDYNEK LETNISKOWY W CHORWACJI/5.jpg",
        ],
    },

    {
        title: "KIOSKI HANDLOWE ORAZ GASTRONOMICZNE W BERLINIE",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/9_KIOSKI HANDLOWE ORAZ GASTRONOMICZNE W BERLINIE/0.jpg",
            "/strona-www/9_KIOSKI HANDLOWE ORAZ GASTRONOMICZNE W BERLINIE/1.jpg",
            "/strona-www/9_KIOSKI HANDLOWE ORAZ GASTRONOMICZNE W BERLINIE/2.jpg",
            "/strona-www/9_KIOSKI HANDLOWE ORAZ GASTRONOMICZNE W BERLINIE/3.jpg",
        ],
    },

    {
        title: "KONCEPCJA HOTELI NA WODZIE W ROŻOWIE",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/14_KONCEPCJA HOTELI NA WODZIE W ROŻOWIE/0.jpg",
            "/strona-www/14_KONCEPCJA HOTELI NA WODZIE W ROŻOWIE/1.jpg",
            "/strona-www/14_KONCEPCJA HOTELI NA WODZIE W ROŻOWIE/2.jpg",
            "/strona-www/14_KONCEPCJA HOTELI NA WODZIE W ROŻOWIE/3.jpg",
            "/strona-www/14_KONCEPCJA HOTELI NA WODZIE W ROŻOWIE/4.jpg",
            "/strona-www/14_KONCEPCJA HOTELI NA WODZIE W ROŻOWIE/5.jpg",
        ],
    },

    {
        title: "DOM JEDNORODZINNY - 23L1",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY - 23L1/0.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L1/1.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L1/2.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L1/3.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L1/4.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L1/5.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L1/6.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L1/7.jpg",
        ],
    },
    {
        title: "DOM JEDNORODZINNY - 23L2",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY - 23L2/0.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/1.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/2.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/3.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/4.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/5.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/6.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/7.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/8.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/9.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23L2/10.jpg",
        ],
    },

    {
        title: "DOM JEDNORODZINNY - 23X1",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY - 23X1/0.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23X1/1.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23X1/2.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23X1/3.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23X1/4.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23X1/5.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23X1/6.jpg",
        ],
    },
    {
        title: "DOM JEDNORODZINNY - 23Z1",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY - 23Z1/0.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z1/1.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z1/2.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z1/3.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z1/4.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z1/5.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z1/6.jpg",
        ],
    },
    {
        title: "DOM JEDNORODZINNY - 23Z2",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY - 23Z2/0.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z2/1.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z2/2.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z2/3.jpg",
            "/strona-www/DOM JEDNORODZINNY - 23Z2/4.jpg",
        ],
    },
    {
        title: "DOM JEDNORODZINNY ST-1",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY ST-1/0.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-1/1.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-1/2.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-1/3.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-1/4.jpg",
        ],
    },
    {
        title: "DOM JEDNORODZINNY ST-2",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/DOM JEDNORODZINNY ST-2/0.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-2/1.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-2/2.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-2/3.jpg",
            "/strona-www/DOM JEDNORODZINNY ST-2/4.jpg",
        ],
    },
    {
        title: "INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/0.jpg",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/1.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/2.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/3.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/4.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/5.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/6.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/7.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/8.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/9.png",
            "/strona-www/INWENTARYZACJA BUDYNKÓW NA BAZIE CHMURY PUNKTÓW W GLIWICACH/10.png",
        ],
    },
    {
        title: "BUDYNEK MIESZKALNY W DUCHNICACH",
        content: "Jest to projekt hotelu w uściu gorlickim",
        images: [
            "/strona-www/duchnice/0.jpg",
            "/strona-www/duchnice/1.png",
            "/strona-www/duchnice/2.png",
            "/strona-www/duchnice/3.png",
            "/strona-www/duchnice/4.png",
        ],
    },
];

const iconsData = [
    {
        title: "PROJEKTY INDYWIDUALNE",
        description:
            "Wspólnie stworzymy unikalny projekt, który spełni wszystkie Twoje wymagania i preferencje. Projekt indywidualny uwzględnia zarówno funkcjonalność, jak i estetykę, aby stworzyć spersonalizowane rozwiązanie.  Oferujemy kompleksową obsługę pełnego procesu inwestycyjnego poprzez koncepcję, projekt budowlany wraz z uzyskaniem pozwolenia na budowę, oraz projekt techniczny wraz z prowadzeniem nadzoru na budowie.",
        path: "/icons/projekty-indywidualne.png",
    },
    {
        title: "ANALIZA DZIAŁKI",
        description:
            "Przeanalizujemy Twoją działkę budowlaną pod względem różnych czynników, które mają wpływ na Twoją przyszłą inwestycję, oraz jej potencjał pod zabudowę. Analiza działki budowlanej powinna uwzględniać wiele różnych czynników, aby ocenić jej potencjał do zabudowy i określić, jakie rodzaje budynków lub inwestycji mogą być na niej zrealizowane.",
        path: "/icons/analiza.png",
    },
    {
        title: "BUDOWNICTWO MODUŁOWE",
        description:
            "Mamy doświadczenie w projektowanie budynków modułowych o konstrukcji stalowej lub drewnianej. Zajmujemy się adaptacją projektów gotowych oraz opracowaniem projektów indywidualnych, dostosowanych pod budownictwo modułowe.",
        path: "/icons/bud-modulowe.png",
    },
    {
        title: "BUDOWNICTWO PASYWNE",
        description:
            "Nasz zespół posiada duże doświadczenie w projektowaniu budynków pasywnych jak i energooszczędnych. Nasze rozwiązania minimalizują zużycie energii i zasobów naturalnych, jednocześnie zapewniając komfortowe warunki dla mieszkańców. Poprzez przemyślane projektowanie przestrzeni, efektywne systemy grzewcze i chłodzące oraz umiejętny dobór i użycie energii odnawialnej, zapewnimy jak najlepsze parametry energetyczne Twojego budynku",
        path: "/icons/bud-pasywne.png",
    },
    {
        title: "CHMURA PUNKTÓW",
        description:
            "Stworzymy precyzyjny model BIM na bazie chmury punktów. Chmury punktów mogą być wykorzystane do rekonstrukcji i modelowania trójwymiarowych obiektów. Można na ich podstawie tworzyć modele 3D, zarówno ogólne jak i szczegółowe, które odzwierciedlają rzeczywiste kształty i struktury obiektów. Dzięki inwentaryzacji za pomocą chmury punktów jesteśmy pewni dokładności oraz precyzji wykonanej inwentaryzacji, co znacznie ułatwia dalszą pracę związaną z inwentaryzowanym budynkiem. Sama chmura punktów, to trójwymiarowy model cyfrowy, który reprezentuje przestrzeń za pomocą ogromnej ilości punktów w trójwymiarowej przestrzeni. Współpracujemy z firmami zewnętrznymi wykonującymi chmury punktów na terenie całej Polski.",
        path: "/icons/chmura-punktow.png",
    },
    {
        title: "PROJEKTOWANIE BIM",
        description:
            "Projektujemy w technologii BIM (Building Information Modeling). To metoda projektowania i zarządzania informacjami o budynku w cyfrowym środowisku. BIM wykorzystuje trójwymiarowe modele cyfrowe, które integrują dane geometryczne, informacje o materiałach, parametry techniczne, harmonogramy, koszty i inne informacje związane z projektem budynku. Dzięki temu proces projektowy jest znacznie usprawniony oraz eliminuje błędy na etapie projektowym oraz wykonawczym.",
        path: "/icons/projektowanie-bim.png",
    },

    {
        title: "PROJEKTY WNĘTRZ",
        description:
            "Wspólnie zaprojektujemy indywidualne wnętrze Twojego mieszkania lub przestrzeni biurowej. Razem stworzymy spersonalizowany i unikalny projekt, który odzwierciedla Twoje preferencje oraz styl życia, przy równoczesnym zachowaniu funkcjonalności, estetyki i harmonii.",
        path: "/icons/projekty-wnetrz.png",
    },
    {
        title: "WIZUALIZACJE I ANIMACJE",
        description:
            "Tworzymy wizualizacje i animacje architektoniczne, które w wyjątkowy sposób przedstawią zamierzenie budowlane, jak i rozwiązania urbanistyczne. Dzięki nim zaprezentujemy  ich wygląd, funkcjonalność i estetykę. Wizualizacje i animacje architektoniczne ułatwiają zrozumienie projektu przez odbiorców, jak również umożliwienie im prezentację naszych pomysłów. ",
        path: "/icons/wizualizacje-animacje.png",
    },
];

export { projectsData, iconsData };
